import { useParams } from "react-router-dom";
import Report from "datasets/pages/dashboards/types/interfaces/report";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const useDatasetReports = (id?: string) => {
  const { datasetId = id } = useParams();

  return useFetcher<Report[]>(
    datasetId ? `${VITE_CATALOG_API}/reports/dataset/${datasetId}` : null
  );
};

export default useDatasetReports;
